/** A short, curated set. A full emoji catalogue would be a dependency and a scrolling chore. */
export const CHAT_EMOJI_GROUPS: { label: string; emoji: string[] }[] = [
  {
    label: "Reactions",
    emoji: ["👍", "🙌", "👏", "💪", "🔥", "🎉", "✨", "❤️", "😂", "😍", "🤝", "🫶"],
  },
  {
    label: "Faces",
    emoji: ["🙂", "😀", "😅", "😊", "😎", "🤔", "😴", "🥵", "🥳", "😭", "🙃", "😬"],
  },
  {
    label: "Walking",
    emoji: ["🚶", "🏃", "🥾", "👟", "🗺️", "⛰️", "🌳", "🌅", "☔", "❄️", "🐕", "🎽"],
  },
  {
    label: "Milestones",
    emoji: ["🏆", "🥇", "🎯", "📈", "⏱️", "📅", "💯", "⭐", "🚀", "🧭", "🍀", "🎖️"],
  },
];
